import { render, staticRenderFns } from "./ShiftLogs.vue?vue&type=template&id=476c078a&scoped=true"
import script from "./ShiftLogs.vue?vue&type=script&lang=js"
export * from "./ShiftLogs.vue?vue&type=script&lang=js"
import style0 from "./ShiftLogs.vue?vue&type=style&index=0&id=476c078a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c078a",
  null
  
)

export default component.exports